import { render, staticRenderFns } from "./record.vue?vue&type=template&id=3637cf3a&scoped=true&"
import script from "./record.vue?vue&type=script&lang=js&"
export * from "./record.vue?vue&type=script&lang=js&"
import style0 from "./record.vue?vue&type=style&index=0&id=3637cf3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3637cf3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3637cf3a')) {
      api.createRecord('3637cf3a', component.options)
    } else {
      api.reload('3637cf3a', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=3637cf3a&scoped=true&", function () {
      api.rerender('3637cf3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/create/record.vue"
export default component.exports